// Main JS Here.js'

// ── Copy to Clipboard button (auhasard/copy-button) ───────────────────────
document.querySelectorAll( '.auhasard-copy-button__link[data-copy-value]' ).forEach( ( btn ) => {
	btn.addEventListener( 'click', () => {
		navigator.clipboard.writeText( btn.dataset.copyValue ).then( () => {
			const original = btn.textContent;
			btn.textContent = btn.dataset.copiedLabel || 'Copié !';
			btn.disabled = true;
			setTimeout( () => {
				btn.textContent = original;
				btn.disabled = false;
			}, 2000 );
		} );
	} );
} );
